/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  CaretDownOutlined,
  Loading3QuartersOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import {
  Avatar,
  Button,
  Card,
  Carousel,
  Col,
  Dropdown,
  Image,
  Row,
  Spin,
  Switch,
  Tag,
} from "antd";
import {
  AngleRight,
  // ContractsIcon,
  DeleteIcon,
  PlusIcon,
  TickIcon,
} from "../../../../../atoms/CustomIcons";
import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../config/hooks";
import {
  getTaskDetails,
  getTaskListing,
  removeTaskDetailData,
} from "../../../ducks/actions";
import UploadFullMultiple from "../../../../../atoms/UploadPhoto/UploadFullMultiple";
import { RcFile } from "antd/es/upload";
import { deleteTask, uploadUserImageBulk } from "../../../ducks/services";
import { SuccessMessage } from "../../../../../atoms/Toasts/SuccessMessage";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../../atoms/Toasts/ErrorMessage";
import PlacePicker from "../../../Components/Filters/PlacePicker";
import { SOURCE_TYPE } from "../../../../../config/utils";
import { useNavigate } from "react-router-dom";
import ConfirmDelete from "../../../../../atoms/ConfirmDelete";
import { PopUp } from "../../../../../atoms/PopUp";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  tableRecord: any;
  loading: boolean;
  companyId: string;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const TaskModal = (props: PropsType) => {
  const { loading, tableRecord, setLoading, companyId, onClose } = props;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const dropdownRef = useRef<HTMLButtonElement>(null);
  const [requiredProof, setRequiredProof] = useState<boolean>(false);
  const [attachFiles, setAttachFiles] = useState<boolean>(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [checklistFile, setChecklistFile] = useState<File[] | null>(null);
  const [defaultCenter, setDefaultCenter] = useState<
    { lat: number; lng: number } | undefined
  >();
  const [details, setDetails] = useState<{
    lat: number;
    lng: number;
    placeId?: string;
    formattedAddress?: string;
    addressComponents?: google.maps.GeocoderAddressComponent[];
  }>();

  const taskDetailData = useAppSelector(
    (state) => state?.workOrders?.taskDetailData
  );

  // const contentStyle: React.CSSProperties = {
  //   margin: 0,
  //   height: "160px",
  //   color: "#fff",
  //   lineHeight: "160px",
  //   textAlign: "center",
  //   // background: "#364d79",
  //   // backgroundImage: "url(/images/work-orders/landscape-demo.jpg)",
  //   // backgroundRepeat: "no-repeat",
  //   // backgroundPosition: "center",
  //   // backgroundSize: "cover",
  // };

  const statusItems = [
    {
      key: "open",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#6C7478", borderRadius: "2px" }}
          />{" "}
          Open{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "scheduled",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#6454F4", borderRadius: "2px" }}
          />{" "}
          Scheduled{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "completed",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#00A07D", borderRadius: "2px" }}
          />{" "}
          Completed{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "in_progress",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#943AF5", borderRadius: "2px" }}
          />{" "}
          In progress{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
  ];

  useEffect(() => {
    dispatch(removeTaskDetailData());
  }, [dispatch]);

  useEffect(() => {
    if (tableRecord?.id) {
      dispatch(getTaskDetails(tableRecord?.id));
    }
  }, [dispatch, tableRecord?.id]);

  const saveAttachments = () => {
    setLoading(true);
    if (checklistFile && tableRecord?.id) {
      uploadUserImageBulk({
        owner_id: tableRecord?.id,
        image: checklistFile as File[] | RcFile[],
        image_type: "task_work_files",
      })
        .then((res) => {
          if (res) {
            setLoading(false);
            SuccessMessage("Attachment added");
            dispatch(getTaskDetails(tableRecord?.id));
            setAttachFiles(false);
            setChecklistFile(null);
          }
        })
        .catch((e: unknown) => {
          if (e instanceof AxiosError) {
            setLoading(false);
            ErrorMessage(
              e?.response?.data?.error?.message ?? "Something went wrong"
            );
          } else {
            setLoading(false);
            ErrorMessage("Something went wrong");
          }
        });
    } else {
      setLoading(false);
      SuccessMessage("Task updated");
    }
  };

  useEffect(() => {
    if (taskDetailData?.data?.latitude || taskDetailData?.data?.longitude) {
      setDetails({
        lat: taskDetailData.data.latitude,
        lng: taskDetailData.data.longitude,
      });
      setDefaultCenter({
        lat: parseFloat(taskDetailData.data.latitude.toString()),
        lng: parseFloat(taskDetailData.data.longitude.toString()),
      });
    }
    if (taskDetailData?.data?.proof_of_completion) {
      setRequiredProof(taskDetailData?.data?.proof_of_completion);
    } else {
      setRequiredProof(false);
    }
  }, [taskDetailData]);

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/edit-task/${tableRecord?.id}/${companyId}`);
          }}
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
        >
          Edit details
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          onClick={(e) => {
            e.stopPropagation();
            setIsDeleteModalOpen(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
          className="delete-hover"
          icon={<DeleteIcon />}
        >
          Delete
        </Button>
      ),
    },
  ];

  const deleteFunction = () => {
    setLoading(true);
    deleteTask([tableRecord?.id || ""])
      .then(() => {
        setLoading(false);
        const payload = {
          status: undefined,
          offset: 0,
          limit: 10,
          company_id: companyId,
          // type: filters?.type ?? undefined,
          search_text: undefined,
        };
        dispatch(getTaskListing(payload));
        SuccessMessage("Task deleted");
        setIsDeleteModalOpen(false);
        onClose();
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const confirmDeleteTask = {
    visibility: isDeleteModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsDeleteModalOpen(false)}
        heading="Confirm deletion"
        paragraph={
          <>
            Are you sure you want to delete <b>{tableRecord?.name}</b>?
            <br />
            <br />
            This action cannot be undone.
          </>
        }
        btnText="Delete task"
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setIsDeleteModalOpen(false),
  };

  console.log("defaultCenter", defaultCenter);

  return (
    <Spin
      indicator={antIcon}
      size="large"
      spinning={loading || taskDetailData.loader}
    >
      <Row wrap={false} gutter={8} className="TaskModalWrapper">
        <Col flex="auto" className="TaskModalLeft">
          <Card className="taskModalCard">
            <div className="taskModalHeader">
              <div className="taskBreadcrumb">
                <span
                  className="taskBreadcrumbItem"
                  style={{ color: "#98A3A9" }}
                >
                  Tasks
                </span>
                <AngleRight />
                <span className="taskBreadcrumbItem active">Task details</span>
              </div>

              {/* <div className="activityBtn">
                <Button
                  icon={<ContractsIcon />}
                  className="outlined-btn btn-sm"
                >
                  Activity history
                </Button>
              </div> */}
            </div>

            <div className="taskModalContent">
              <div className="taskContent">
                <h2>{taskDetailData?.data?.name}</h2>
                <div
                  dangerouslySetInnerHTML={{
                    __html: taskDetailData?.data?.details ?? "",
                  }}
                />
              </div>
              <div className="taskAttachments">
                <Row>
                  <div
                    className="attachmentsTitle"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      marginBottom: "12px",
                    }}
                  >
                    <h3>Attachments</h3>
                    <Button
                      icon={<PlusIcon />}
                      className="outlined-btn btn-sm"
                      onClick={() => setAttachFiles(!attachFiles)}
                    >
                      Add attachments
                    </Button>
                  </div>
                  {attachFiles && (
                    <Card className="addAttachmentsCard">
                      <UploadFullMultiple
                        saveUpload={() => null}
                        loading={false}
                        onImageDelete={() => null}
                        // previewImage={previewImage}
                        // checklistFile={checklistFile}
                        // modalPreviewImage={modalPreviewImage}
                        setChecklistFile={setChecklistFile}
                        // setPreviewImage={setPreviewImage}
                        // setModalPreviewImage={setModalPreviewImage}
                      />
                      <Button
                        onClick={() => saveAttachments()}
                        className="mint-btn"
                      >
                        Save attachments
                      </Button>
                    </Card>
                  )}
                </Row>
                <Row gutter={12}>
                  <Col span={12} className="attachmentCarousel">
                    <div className="attachmentTag">
                      <Tag className="shaded_green_tag">Before</Tag>
                    </div>
                    {taskDetailData?.data?.files &&
                    taskDetailData?.data?.files?.length > 0 ? (
                      <Carousel arrows infinite={false}>
                        {taskDetailData.data.files
                          .filter((item) => item?.type === "task_work_files")
                          .map((item, index) => (
                            <div key={index}>
                              <img
                                src={item?.url}
                                alt={`Attachment ${index + 1}`}
                                style={{
                                  width: "100%",
                                  height: "245px",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                          ))}
                      </Carousel>
                    ) : (
                      <Card className="requiredProofCard">
                        <div
                          className="attachmentImage"
                          style={{ flexWrap: "wrap" }}
                        >
                          <img
                            src="/images/potential-deals/image-icon.svg"
                            style={{ width: "48px", height: "48px" }}
                            alt=""
                          />
                          <span
                            style={{
                              display: "block",
                              width: "100%",
                              textAlign: "center",
                            }}
                          >
                            No attachments found
                          </span>
                        </div>
                      </Card>
                    )}
                  </Col>
                  <Col span={12}>
                    <Card className="requiredProofCard">
                      <div className="attachmentTag">
                        <Tag className="shaded_red_tag">After</Tag>
                      </div>
                      <div className="attachmentImage">
                        <img
                          src="/images/potential-deals/image-icon.svg"
                          style={{ width: "48px", height: "48px" }}
                          alt=""
                        />
                        {/* {taskDetailData?.data?.files &&
                        taskDetailData?.data?.files?.length > 0 ? (
                          <Carousel arrows infinite={false}>
                            {taskDetailData.data.files
                              .filter(
                                (item) => item?.type === "task_work_files"
                              )
                              .map((item, index) => (
                                <div key={index}>
                                  <img
                                    src={item?.url}
                                    alt={`Attachment ${index + 1}`}
                                    style={{
                                      width: "100%",
                                      height: "245px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>
                              ))}
                          </Carousel>
                        ) : (
                          <img
                            src="/images/potential-deals/image-icon.svg"
                            style={{ width: "48px", height: "48px" }}
                            alt=""
                          />
                        )} */}
                      </div>
                      <div className="switchBox">
                        <Switch
                          onChange={() => setRequiredProof(!requiredProof)}
                          checked={requiredProof}
                        />
                        <div>
                          <div className="requiredHeading">
                            Requires proof of completion
                          </div>
                          <div className="requiredParagraph">
                            The crew leader will be required to take a photo or
                            video upon visit completion.
                          </div>
                        </div>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </div>
              {defaultCenter && (
                <div className="taskLocation">
                  <h3 style={{ marginBottom: "12px" }}>Location</h3>

                  <PlacePicker
                    setDetails={setDetails}
                    details={details ?? { lat: 0, lng: 0 }}
                    defaultCenter={defaultCenter}
                    hideSearch
                  />
                </div>
              )}
            </div>
          </Card>
        </Col>
        <Col flex="360px" className="TaskModalRight">
          <div className="taskSidebarWrapper">
            <div className="taskSidebarHeader">
              <h4>Details</h4>
              <Dropdown
                menu={{ items }}
                trigger={["click"]}
                placement="bottomRight"
                className="actionButton"
              >
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
                  className="btn-sm"
                  icon={<MoreOutlined />}
                  ref={dropdownRef}
                />
              </Dropdown>
            </div>

            <div className="sidebarRow">
              <div className="sidebarLabel">Status</div>
              <div className="sidebarValue">
                {taskDetailData?.data?.status === "in_progress" ? (
                  <Tag
                    style={{ textTransform: "capitalize" }}
                    className={`status_dropdown ${taskDetailData?.data?.status}_status`}
                  >
                    {taskDetailData?.data?.status === "in_progress"
                      ? "In progress"
                      : taskDetailData?.data?.status ?? "Open"}
                  </Tag>
                ) : (
                  <Dropdown
                    menu={{
                      items: statusItems,
                      selectable: true,
                      selectedKeys: [taskDetailData?.data?.status ?? "open"],
                    }}
                    trigger={["click"]}
                    overlayClassName="status_dropdown_overlay"
                  >
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      onKeyDown={(e) => e.stopPropagation()}
                      className={`status_dropdown ${taskDetailData?.data?.status}_status`}
                      style={{ textTransform: "capitalize" }}
                      // disabled
                    >
                      {taskDetailData?.data?.status ?? "Open"}
                      <div className="icon_arrow">
                        <CaretDownOutlined />
                      </div>
                    </Button>
                  </Dropdown>
                )}
              </div>
            </div>
            <div className="sidebarRow">
              <div className="sidebarLabel">Occurrences</div>
              <div className="sidebarValue">32</div>
            </div>
            <div className="sidebarRow">
              <div className="sidebarLabel">Assignee</div>
              <div className="sidebarValue">
                <div className="textWithAvatar">
                  <Avatar src="/images/dummy/user.png" />
                  <div className="avatarText">Jack M.</div>
                </div>
              </div>
            </div>
            <div className="sidebarRow">
              <div className="sidebarLabel">Source</div>
              <div className="sidebarValue">
                {taskDetailData?.data?.source
                  ? SOURCE_TYPE[
                      taskDetailData?.data?.source as keyof typeof SOURCE_TYPE
                    ]
                  : "-"}
              </div>
            </div>
          </div>

          <div className="taskSidebarWrapper">
            <div className="taskSidebarHeader">
              <h4>Property</h4>
            </div>

            <div className="sidebarRow">
              <div className="sidebarLabel">Property</div>
              <div className="sidebarValue">
                <span>{taskDetailData?.data?.property_name ?? "-"}</span>
                <Button
                  icon={
                    <Image
                      src="/images/work-orders/link-icon.svg"
                      preview={false}
                    />
                  }
                  className="only_icon"
                />
              </div>
            </div>
            <div className="sidebarRow">
              <div className="sidebarLabel">Contract</div>
              <div className="sidebarValue">
                <span>{taskDetailData?.data?.contract_name ?? "-"}</span>
                <Button
                  icon={
                    <Image
                      src="/images/work-orders/link-icon.svg"
                      preview={false}
                    />
                  }
                  className="only_icon"
                />
              </div>
            </div>
            <div className="sidebarRow">
              <div className="sidebarLabel">Work order</div>
              <div className="sidebarValue">
                {taskDetailData?.data?.work_order_name ?? "-"}
              </div>
            </div>
            <div className="sidebarRow">
              <div className="sidebarLabel">Production manager</div>
              <div className="sidebarValue">
                <div className="textWithAvatar">
                  <Avatar
                    src={
                      taskDetailData?.data?.production_manager_image_url ?? ""
                    }
                  />
                  <div className="avatarText">
                    {taskDetailData?.data?.production_manager_name ?? ""}
                  </div>
                </div>
              </div>
            </div>
            <div className="sidebarRow">
              <div className="sidebarLabel">Property address</div>
              <div className="sidebarValue">
                <span>{taskDetailData?.data?.property_address ?? "-"}</span>
                <Button
                  icon={
                    <Image
                      src="/images/work-orders/link-icon.svg"
                      preview={false}
                    />
                  }
                  className="only_icon"
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <PopUp {...confirmDeleteTask} />
    </Spin>
  );
};

export default TaskModal;
